import { FUNCTIONS_BASE_URL } from '@/shared/config/environment';

export interface CreatePayPalOrderRequest {
    organizationId: string;
    amount: number; // En centimes
    currency: string;
    customerEmail: string;
    customerName: string;
    description: string;
    metadata?: Record<string, any>;
}

export interface PayPalOrderResponse {
    paymentIntentId: string;
    clientSecret: string; // Pour PayPal, c'est l'ID d'ordre
    status: string;
    amount: number;
    currency: string;
}

export const createPayPalOrder = async (data: CreatePayPalOrderRequest): Promise<PayPalOrderResponse> => {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/createPayPalOrder`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to create PayPal order');
    }

    return await response.json();
};

export const capturePayPalOrder = async (orderId: string, organizationId: string): Promise<any> => {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/capturePayPalOrder`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ orderId, organizationId }),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to capture PayPal order');
    }

    return await response.json();
};
